import i18n from "config/i18next";

i18n.addResources("es", "frequency", {
  enterNumber: "Ingresá el n°",
  frequency: "Frecuencia",
  capacity: "Capacidad",
});
